import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiDownload } from 'react-icons/fi';
import BottomTabMenu from '../../components/UI/BottomTabMenu';
import { LoadingGrid } from '../../components/UI/Loading';
import { vendedoresService } from '../../services';

const VendedorClientes = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadClientes();
  }, [id]);

  const loadClientes = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await vendedoresService.getClientesVendedor(id);

      if (result.success) {
        // Transformar los datos de la API
        const clientesData = result.data.map(cliente => ({
          id: cliente.id,
          nombre: cliente.company_name || cliente.full_name || 'N/A',
          email: cliente.email || 'N/A',
          telefono: cliente.phone || cliente.mobile || 'N/A',
          ultimaCompra: cliente.last_purchase_date
            ? new Date(cliente.last_purchase_date).toLocaleDateString('es-ES')
            : 'Sin compras',
          totalCompras: parseFloat(cliente.total_purchases || cliente.total_amount || 0)
        }));
        setClientes(clientesData);
      } else {
        setError(result.message || 'Error al cargar los clientes');
        setClientes([]);
      }
    } catch (err) {
      console.error('Error cargando clientes:', err);
      setError('Error de conexión al cargar los clientes');
      setClientes([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    console.log('Exportar lista de clientes del vendedor:', id);
    alert('Función de exportación próximamente');
  };

  if (isLoading) {
    return <LoadingGrid message="Cargando lista de clientes..." />;
  }

  return (
    <div className="vendedor-clientes-page">
      {/* Error message */}
      {error && (
        <div className="alert alert--danger" style={{ margin: '20px' }}>
          <strong>Error:</strong> {error}
          <button
            className="btn btn--ghost btn--sm"
            onClick={loadClientes}
            style={{ marginLeft: '10px' }}
          >
            Reintentar
          </button>
        </div>
      )}

      {/* Header */}
      <div className="form-header">
        <button
          className="btn btn--ghost"
          onClick={() => navigate('/system/vendedores')}
          type="button"
        >
          <FiArrowLeft /> Volver a Vendedores
        </button>

        <h1 className="form-title">
          LISTA DE CLIENTES ASIGNADOS
        </h1>

        <div className="form-actions">
          <button
            className="btn btn--primary"
            onClick={handleExport}
            type="button"
          >
            <FiDownload /> Exportar
          </button>
        </div>
      </div>

      {/* Contenido */}
      <div className="page-content">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>CLIENTE</th>
                <th>EMAIL</th>
                <th>TELÉFONO</th>
                <th>ÚLTIMA COMPRA</th>
                <th className="text-right">TOTAL COMPRAS</th>
              </tr>
            </thead>
            <tbody>
              {clientes.map((cliente) => (
                <tr
                  key={cliente.id}
                  onClick={() => navigate(`/system/clientes/${cliente.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <td><strong>{cliente.nombre}</strong></td>
                  <td>{cliente.email}</td>
                  <td>{cliente.telefono}</td>
                  <td>{cliente.ultimaCompra}</td>
                  <td className="text-right">
                    <strong style={{ color: '#28a745' }}>${cliente.totalCompras.toLocaleString()}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Menú inferior */}
      <BottomTabMenu
        baseRoute={`/system/vendedores/${id}`}
        currentTab="clientes"
        tabs={[
          { id: 'datos', label: 'Datos', route: '' },
          { id: 'ventas', label: 'Reporte de Ventas', route: '/ventas' },
          { id: 'comisiones', label: 'Reporte de Comisiones', route: '/comisiones' },
          { id: 'clientes', label: 'Lista de Clientes', route: '/clientes' },
          { id: 'grafica', label: 'Gráfica de Ventas', route: '/grafica' },
          { id: 'notas', label: 'Notas', route: '/notas' }
        ]}
      />
    </div>
  );
};

export default VendedorClientes;
